import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { KeyRound, Loader2 } from 'lucide-react';
import { useAdminAuth } from '../../context/AdminAuthContext';
import { validateAdminKey } from '../../utils/adminApi';

export default function AdminLoginPage() {
  const [key, setKey]       = useState('');
  const [error, setError]   = useState('');
  const [loading, setLoading] = useState(false);
  const { loginAdmin }      = useAdminAuth();
  const navigate            = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    if (!key.trim()) return;
    setError('');
    setLoading(true);
    try {
      await validateAdminKey(key.trim());
      loginAdmin(key.trim());
      navigate('/inqlect-admin', { replace: true });
    } catch (err) {
      setError(err.message || 'Invalid admin key.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="admin-login-wrap">
      <div className="admin-login-card">
        <div className="admin-login-logo">
          <KeyRound size={32} />
        </div>
        <h1 className="admin-login-title">InqLect Admin</h1>
        <p className="admin-login-sub">Enter your admin key to continue</p>

        <form onSubmit={handleSubmit} className="admin-login-form">
          <input
            type="password"
            className="admin-input"
            placeholder="Admin key"
            value={key}
            onChange={e => setKey(e.target.value)}
            autoFocus
          />
          {error && <p className="admin-error">{error}</p>}
          <button className="admin-btn-primary" disabled={loading || !key.trim()}>
            {loading ? <Loader2 size={16} className="spin" /> : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
